export default function Hero() {
  return (
    <section className="relative min-h-screen w-full overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=modern%20warehouse%20distribution%20center%20with%20organized%20shelves%20and%20professional%20logistics%20operations%20clean%20industrial%20interior%20with%20natural%20lighting%20and%20systematic%20inventory%20management%20professional%20business%20environment&width=1920&height=1080&seq=hero-warehouse-001&orientation=landscape"
          alt="Warehouse Operations"
          className="w-full h-full object-cover object-center"
        />

        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-transparent"></div>
      </div>

      {/* Content */}
      <div className="relative flex items-center min-h-screen pt-24 md:pt-0">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 w-full">
          <div className="max-w-4xl">
            <h1 className="text-3xl md:text-6xl lg:text-7xl xl:text-8xl font-bold text-white leading-tight md:leading-tight tracking-tight mb-8">
              WHOLESALE.
              <br />
              OPERATIONS.
              <br />
              DONE RIGHT.
            </h1>

            <p className="text-lg lg:text-xl text-white/90 mb-12 max-w-3xl leading-relaxed">
              AKTEN INC is a US-based wholesale and marketplace operations company. We source products directly from authorized wholesalers and publishers, and operate our own Amazon and Walmart stores.
              <br />
              You focus on inventory — we handle compliance, pricing, and daily operations.
            </p>

            <div className="flex flex-wrap gap-4">
              <a
                href="#partnership"
                className="px-8 py-4 bg-akten text-white text-base font-semibold rounded-full hover:bg-akten-dark transition-all duration-300 flex items-center space-x-2 cursor-pointer whitespace-nowrap"
              >
                <span>Partner With Us</span>
                <i className="ri-arrow-right-line text-xl"></i>
              </a>

              <a
                href="#contact"
                className="px-8 py-4 bg-transparent border-2 border-white/90 text-white text-base font-semibold rounded-full hover:bg-white/10 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                Become a Supplier
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
